module.exports = __webpack_public_path__ + "home_bus1.6acf08fffb2e111cb1c3.png";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/home_bus1.png
// module id = ../../../../../src/assets/images/home_bus1.png
// module chunks = 1